import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { PlusCircle } from "lucide-react";
import SortableItem from './SortableItem';

export default function KanbanColumn({ 
  column, 
  items,
  onAddCard
}) {
  const { t } = useTranslation();
  const { id, title, color } = column;
  
  const { setNodeRef, isOver, active } = useDroppable({
    id: `column-${id}`,
    data: {
      type: 'column',
      column
    }
  });
  
  return (
    <Card 
      ref={setNodeRef}
      className={`h-full ${isOver ? 'ring-2 ring-primary' : ''}`}
      data-column-id={id}
    >
      <div className="px-4 py-2 border-b">
        <div className="flex items-center justify-between">
          <h3 className="font-medium text-lg text-[#475569]">
            {title}
          </h3>
          <span className="text-sm text-muted-foreground font-medium">
            ({items.length})
          </span>
        </div>
      </div>
      <div className="p-4" data-column-id={id}>
        <SortableContext
          items={items.map(item => item._id)}
          strategy={verticalListSortingStrategy}
        >
          {items.map((item) => (
            <SortableItem key={item._id} id={item._id} item={item} onEdit={onAddCard} />
          ))}
        </SortableContext>
        
        {items.length === 0 && (
          <div className="text-center py-6">
            <p className="text-sm text-muted-foreground">
              {t('kanban.column.empty')}
            </p>
          </div>
        )}
        
        <Button 
          variant="ghost" 
          size="sm" 
          className="w-full mt-4 border border-dashed border-gray-300"
          onClick={() => onAddCard(null)}
        >
          <PlusCircle className="h-4 w-4 mr-2" />
          {t('kanban.column.add')}
        </Button>
      </div>
    </Card>
  );
}
